import { render, staticRenderFns } from "./VendorView.vue?vue&type=template&id=241090cc&scoped=true&"
import script from "./VendorView.vue?vue&type=script&lang=js&"
export * from "./VendorView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241090cc",
  null
  
)

export default component.exports